import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

const LanguageSwitcher = () => {
  const { language, cycleLanguage } = useLanguage();

  const languageLabels = {
    en: "EN",
    is: "IS",
    lt: "LT",
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={cycleLanguage}
      className="flex items-center gap-2 font-ui text-neutral-600 hover:text-primary-600 hover:bg-primary-50 transition-colors duration-200"
      data-testid="language-switcher"
    >
      <Globe className="w-4 h-4" />
      <span className="text-sm font-medium">
        {languageLabels[language]}
      </span>
    </Button>
  );
};

export default LanguageSwitcher;
